<template>
    <div>
        <top-navbar></top-navbar>
<div class="background_color mb-5">
  

<div  >
  <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Spare Parts  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Inventory  </h6>

  <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar mb-1 background_color">

        <div class="d-flex">
            <b-input-group size="sm" style="width: 225px;">
              <b-form-input id="filter-input" class="bdr-rad" v-model="filter" @input="loadMiinventory()" type="search" placeholder="Search">
              </b-form-input>
            </b-input-group>

            
          

    <div style="margin-top: 11px;" class="ms-2" >
    <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
  </div>

        </div>
  


<div  style="margin-top:-20px; margin-right: -2px;" class="d-grid gap-2 d-md-flex justify-content-md-end">




</div>
</div>



<div class="card bdr-rad2 mt-1 shadow p-2  ">
<div class="card-body " >


<div class="d-flex justify-content-center" v-if="isLoading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div v-else>
  <!-- <div style="border: 0px; padding: 0px; min-height:20px" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
    </div>
    </div> -->






  <b-table responsive style="font-size: small;"  class=" table-hover "
      :items="all_datas"
      :fields="fields"
      :current-page="currentPage"
      head-variant="dark"
      :fixed="fixed"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
    
    >
   


      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>
      <template #cell(number)="row">
                 {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1)*10 + row.index + 1 }} 
                  </template>

      <template #cell(actions)="row">
       
        <button  @click="binLoad(row.item.I_idProduct)"   class="btn btn-sm btn-outline-primary font-size_def bdr-rad">
          View Bin Card
        </button>
      
       
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
  </b-table>
 
      <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-5">
       <b-pagination
      @change="pageChanged"
      v-model="currentPage"
      pills
      :total-rows="totalRows"
      :per-page="perPage"
      size="sm">
    </b-pagination>
      </b-col>

</div>       

     
    
    

  

</div>
</div>
</div>
</div>



<br><br>




</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        FromDate: null,
        ToDate: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        all_datas:[],
       
        fields: [
          { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
          { key: 'brand_name', label: 'Brand', sortable: true, sortDirection: 'desc' },
          { key: 'spare_parts', label: 'Product Category', sortable: true, sortDirection: 'desc' },
          { key: 'P_code', label: 'Product Code', sortable: true, sortDirection: 'desc' },
          { key: 'P_description', label: 'Product Description', sortable: true, sortDirection: 'desc' },
          { key: 'fuel_type', label: 'Fuel Type', sortable: true, sortDirection: 'desc' },
          { key: 'total_qty', label: 'Quantity', sortable: true, sortDirection: 'desc' },
          { key: 'P_internal_selling_price', label: 'Selling Price ($)', sortable: true, sortDirection: 'desc' },
        
         
          
          { key: 'actions', label: 'Actions', class:'width-custom4', }
        ],
        isLoading: true, 
      


        
      }

    },
    computed: {
     
    },
    mounted(){
     
      
  this.loadMiinventory();


    },
methods : {

  serchCustom(id) {

this.filterOn = id;
  },

  // onFiltered(filteredItems) {
  //       // Trigger pagination to update the number of buttons/pages due to filtering
  //       this.totalRows = filteredItems.length
  //       this.currentPage = 1
  //     },

  async binLoad(id) {

    this.$router.push('/cmmsinventory/indexbyproduct?id='+id);
  },
  
  async loadMiinventory(page = this.currentPage) {
    try {
      const { data} = await  axios.get('/cmsiinventory/index',{
        params: {
            page: page,
            perPage: this.perPage,
            filter: this.filter,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          },
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.all_datas = data.all_data;
        this.totalRows = data.total_count;
        this.currentPage = data.page;
        this.isLoading = false;
        
      
    } catch (error) {
      console.log(error.response);
    }
  },


  pageChanged(newPage) {
      if (newPage !== this.previousPage) {
        console.log("Page changed to:", newPage);
        this.previousPage = newPage; // Update previous page tracker
        this.loadMiinventory(newPage);
      }
    },

   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar,
        DatePicker,
    },
  }

</script>
<style >

</style>